export default __webpack_public_path__ + "static/media/video-security-and-analytics.en.d9f027e6.vtt";